<template>
  <div class="">
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="true"
            :bigTotal="bigTotal"
            :loading="loading" :total="bigTotal"
            :label="'Promoteur'">
      <router-link :to="{name: 'PromoteurCreate'}" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-plus-square"></i></span>
        <span>Nouveau Promoteur</span>
      </router-link>
      <a @click="loadItems()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-sync"></i></span>
        <span>Actualiser</span>
      </a>
    </sticky>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div class="page-content columns collapseColumn collapseColumn--left collapseColumn--alignStart"
         id="columns-collapse"
         :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-4 is-3-widescreen is-3-fullhd">
        <list-filter @resetFilters="resetFilters"
                     @changeFilters="changeFilters"
                     :total="total"
                     :bigTotal="bigTotal"
                     :loading="loading"
                     :hasFilter="hasFilter"
                     @opened="opened = !opened">
          <div class="columns">
            <div class="column is-padding-top-small is-paddingless-bottom">
              <div class="control">
                <input class="input" type="text" placeholder="Promoteur" v-model="filters.name" @input="inputChange">
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-padding-top-small">
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="filters.flux_enabled" @change="updateFluxFilter(filters.flux_enabled)">
                    <option :value="null" selected>Flux actif/inactif</option>
                    <option :value="1">Flux actif</option>
                    <option :value="0">Flux inactif</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </list-filter>
      </div>
      <div class="column is-8 is-9-widescreen is-9-fullhd">
        <div class="is-border">
          <div class="columns is-gapless row-width-actions-bar is-border-bottom">
            <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster" mode="out-in">
              <div class="column is-narrow has-bg-primary columns is-vcentered is-gapless" v-if="hasFilter && !loading && total !== bigTotal">
                <div class="column is-padding-left is-padding-right has-text-white">Résultat : {{total || 0}} promoteur(s)</div>
              </div>
            </transition>
            <div class="column"></div>
            <div class="column is-narrow">
              <button class="page-header-btn is-square is-static is-ghost">
                <span class="icon"><i class="fas fa-sort-amount-upXX"></i></span>
              </button>
            </div>
          </div>
          <div class="column is-narrow is-padding-top-small is-padding-bottom-small">
            <div class="tags">
              <span class="tag is-danger"><span>Flux inactif</span></span>
              <span class="tag is-success"><span>Flux actif</span></span>
            </div>
          </div>
          <div class="is-padding is-border-bottom" v-if="hasFilter">
            <label for="" class="is-size-6 label is-padding-bottom-small">Vos critères de recherche :</label>
            <div class="tags">
              <span class="tag is-primary is-rounded" v-if="filters.name">
                {{filters.name}} <a @click="deleteFilterAlone('name')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-annonce is-rounded has-cursor-pointer" @click="resetFilters">
                Réinitialiser les filtres <span class="icon is-white is-margin-left-xsmall"><i class="fas fa-undo"></i></span>
              </span>
            </div>
          </div>
          <div>
            <table v-show="!loading && items.length" 
                   class="table is-fullwidth is-marginless-bottom is-first-fixed-small is-radius-bottom-left is-radius-bottom-right">
              <thead>
              <tr class="is-size-6">
                <th class="has-text-left">
                  <sortable @sort="sort('flux_enabled', $event)" :sort="sortBy.flux_enabled"
                            label="Flux Actif"></sortable>
                </th>
                <th class="has-text-left">
                  <sortable @sort="sort('name', $event)" :sort="sortBy.name" label="Nom"></sortable>
                </th>
                <th v-if="isSuperAdmin" class="has-text-left">
                  Heure Synchro
                </th>
                <th v-if="isSuperAdmin" class="has-text-left">
                  Dernière Synchro
                </th>
                <th class="has-text-centered is-narrow">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="p in items" :key="p.pk" class="is-size-6" :id="'e' + p.pk" :class="{'has-status-bar--left has-status-bar--draft':scrollToEl === p.pk}">
                <td class="has-text-centered">
                  <span class="dot tooltip" :class="p.flux_enabled ? 'has-bg-success' : 'has-bg-danger'"
                        :data-tooltip="p.flux_enabled ? 'Flux Actif' : 'Flux Inactif'"></span>
                </td>
                <td class="has-text-left">
                  <router-link :to="{name: 'PromoteurVue', params: {id: p.pk}, query: {returnId: p.pk}}">
                    {{ p.name }}
                  </router-link>
                </td>
                <td v-if="isSuperAdmin" class="has-text-left">
                  <span v-if="p.flux && p.flux.cronjob_time">
                    {{p.flux.cronjob_time | prettyCronjobTime}}
                  </span>
                  <span v-else>06h00</span>
                </td>
                <td v-if="isSuperAdmin" class="has-text-left">
                  {{ getLastSynchroInfo(p.pk) | prettyDatetime }}
                </td>
                <td class="has-text-centered actions">
                  <display-button-list :forceDropDown="true" :buttons="buttonList" :data="p"></display-button-list>
                </td>
              </tr>
              <tr class="empty empty--row" v-for="n in items.length < 3 ? 3 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>
              </tbody>
            </table>
            <div class="is-border-top" v-if="totalPage > 1 && nextPage">
              <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
                <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
                <span class="is-size-6">Afficher la suite</span>
              </a>
              <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
            </div>
            <div v-show="!loading && !items.length">
              <div class="columns">
                <div class="column">
                  <h2 class="title is-3 has-text-weight-bold">Aucun promoteur disponible</h2>
                  <a class="has-text-primary" @click="resetFilters" v-if="hasFilter"><span class="icon is-small"><i
                    class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { Sort, Filter, GenericList } from '../../mixins'
  import { isNil, isPlainObject } from 'lodash'

  export default {
    name: 'PromoteurList',
    filters: {
      prettyCronjobTime (value) {
        return value.substr(0, 2) + 'h' + value.substr(2)
      }
    },
    data () {
      return {
        buttonList: [
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'PromoteurVue', params: {id: actionId}, query: {returnId: actionId}})
            },
            icon: 'fa-eye',
            text: 'Voir'
          },
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'PromoteurEdit', params: {id: actionId}, query: {returnId: actionId}})
            },
            icon: 'fa-edit',
            text: 'Éditer'
          },
          {
            action: (id) => {
              this.deleteItem(id)
            },
            icon: 'fa-trash',
            text: 'Supprimer',
            needProfile: ['admin']
          }
        ],
        loadDocuments: this.loadItems,
        service: this.$api.promoteurService,
        opened: true,
        itemName: 'promoteur',
        filters: {flux_enabled: null},
        initFilters: {flux_enabled: null},
        flux: [],
        promoteurs: [],
        selfQueryIn: 'name',
        selfQueryOut: 'promoteur',
        infiniteLoaderEnabled: true
      }
    },
    computed: {
      ...mapState({
        scrollToEl: 'scrollToEl',
        promoteursList: 'promoteurs'
      }),
      ...mapGetters(['isSuperAdmin'])
    },
    mixins: [GenericList, Sort, Filter],
    methods: {
      deleteFilterAlone (val) {
        this.$set(this.filters, val, null)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      async beforeGet () {
        // if (this.query.name) {
        //   const { data } = await this.$api.promoteurService.get({name: this.query.name})
        //   if (data.items && data.items.length) {
        //     this.filters.promoteur = data.items[0]
        //   }
        // }
        if (isPlainObject(this.query.promoteur)) {
          this.query.name = this.query.promoteur.name
        } else if (this.query.promoteur) {
          this.query.name = this.query.promoteur
        }
        delete this.query.promoteur
      },
      updateFluxFilter (e) {
        this.$set(this.filters, 'flux_enabled', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      getLastSynchroInfo (id) {
        let flux = this.flux.find(x => x.promoteur === id)
        if (flux && flux.pk) {
          return flux.created_on
        } else return null
      },
      getFluxInfos () {
        this.$api.fluxService.get({sort: 'created_on:desc'}).then(r => {
          this.flux = r.data.items
        })
      },
      updatePromoteurFilter (e) {
        if (!isNil(e)) this.$set(this.filters, 'name', e)
        else this.$set(this.filters, 'name', undefined)
        this.$nextTick(() => {
          this.changeFilters()
        })
      }
    },
    created () {
      this.getFluxInfos()
      this.promoteurs = this.promoteursList.slice()
      this.$nextTick(() => {
        this.changeFilters()
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/promoteur/PromoteurList.vue